<template>
<div class="container">
    <div>You have a {{user.account.toLowerCase()}} account</div>
</div>

</template>

<script>
export default {
  props: ['user'],

  data() {
    return {
      
    };
  },

  created() {
    
  },

  methods: {

  },
};
</script> 